const PICKING_BUNDLES = [
    'order-picking',
    'order-picking-all',
    'order-picking-attention',
    'order-picking-planned',
    'order-picking-finished',
    'order-picking-backorder',
];

function isPickingGrid(component) {
    return PICKING_BUNDLES.includes(component.bundle);
}

function installTableSelection(component) {
    component.$options.computed = {
        ...component.$options.computed,
        pickingSupportsExclusions() {
            return isPickingGrid(this) && !this.selectables.maximum;
        },
        selectedRowIds: {
            get() {
                if (this.pickingSupportsExclusions && this.selection.allSelected) {
                    return this.objectIds.filter(id => !this.selection.idsExcluded.includes(id));
                }
                return this.selection.idsSelected;
            },
            set(ids) {
                if (this.pickingSupportsExclusions && this.selection.allSelected) {
                    const visibleIds = this.objectIds;
                    this.selection.idsExcluded = [
                        ...this.selection.idsExcluded.filter(id => !visibleIds.includes(id)),
                        ...visibleIds.filter(id => !ids.includes(id)),
                    ];
                    return;
                }
                this.selection.idsSelected = ids;
            },
        },
        selectedRowCount() {
            if (!this.selection.allSelected) return this.selection.idsSelected.length;
            const excluded = this.pickingSupportsExclusions ? this.selection.idsExcluded.length : 0;
            const total = typeof this.pageJumper.selectableCount === 'number'
                ? this.pageJumper.selectableCount
                : this.pageJumper.totalCount;
            return Math.max(0, total - excluded);
        },
    };

    const methods = component.$options.methods;
    component.$options.methods = {
        ...methods,
        selectAll() {
            if (!this.pickingSupportsExclusions) return methods.selectAll.call(this);
            this.selection.idsExcluded = [];
            this.selection.allSelected = !this.selection.allSelected;
            this.selection.idsSelected = this.selection.allSelected ? this.objectIds : [];
            this.autoSelection = false;
            this.closeModal();
        },
        selectMaximum() {
            if (!this.pickingSupportsExclusions) return methods.selectMaximum.call(this);
            this.selection.idsExcluded = [];
            this.selection.idsSelected = this.objectIds.slice();
            this.autoSelection = true;
            this.closeModal();
        },
        clearSelection() {
            if (this.pickingSupportsExclusions) this.selection.idsExcluded = [];
            methods.clearSelection.call(this);
        },
        selectRow(id) {
            if (!this.pickingSupportsExclusions) return methods.selectRow.call(this, id);
            this.selectedRowIds = [...this.selectedRowIds, id];
        },
        deselectRow(id) {
            if (!this.pickingSupportsExclusions) return methods.deselectRow.call(this, id);
            this.selectedRowIds = this.selectedRowIds.filter(selectedId => selectedId !== id);
        },
    };

    const selectedWatcher = component.$options.watch['selection.idsSelected'];
    component.$options.watch = {
        ...component.$options.watch,
        'selection.idsSelected': {
            handler(ids) {
                if (!this.pickingSupportsExclusions) return selectedWatcher.handler.call(this, ids);
                if (!ids.length) {
                    this.autoSelection = false;
                    this.activeSelectAll = this.selection.allSelected;
                }
            },
        },
    };
}

export function installPickingSelection() {
    Vue.mixin({
        beforeCreate() {
            const tag = this.$options._componentTag;
            if (tag === 'ak-data-table-body') {
                installTableSelection(this);
                return;
            }
            if (!['ak-data-table', 'ak-data-wrapper'].includes(tag)) return;

            const getParams = this.$options.computed.addVariablesToDataFetchParams;
            this.$options.computed = {
                ...this.$options.computed,
                addVariablesToDataFetchParams() {
                    const params = getParams.call(this);
                    if (isPickingGrid(this) && this.selection.allSelected) {
                        params.selectexcludeids = this.selection.idsExcluded;
                    }
                    return params;
                },
            };
        },
    });
}
